import { z } from 'zod';

export const Z_UserProfile = z.object({
  organization_name: z.string().nullable(),
  role_id: z.number().nullable(),
  company_size_id: z.number().nullable(),
  inferred_organization_name: z.string().nullable().optional(),
});

export const Z_UserProfileResponse = z.object({
  objects: z.array(Z_UserProfile),
});

export type UserProfile = z.infer<typeof Z_UserProfile>;
export type UserProfileResponse = z.infer<typeof Z_UserProfileResponse>;

export type ExtendedUserProfile = UserProfile & {
  role_name: string;
  company_size_display_range: string;
};
